import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, AbstractControl } from '@angular/forms';
import { map } from 'rxjs/operators';
import { ITrialService } from '../../services/Trial/trial.service.interface';

@Component({
  selector: 'app-organization-account',
  templateUrl: './organization-account.component.html',
  styleUrls: ['./organization-account.component.scss']
})
export class OrganizationAccountComponent implements OnInit {

  formGroup: FormGroup;
  trialService: ITrialService;
  @Output() onCreateForm: EventEmitter<FormGroup>;

  constructor(fb: FormBuilder, trialService: ITrialService) {
    this.trialService = trialService;
    this.onCreateForm = new EventEmitter<FormGroup>();
    this.formGroup = fb.group({
      usernamePrefix: new FormControl("", Validators.compose([Validators.required, this.validatePrefixNumbersandLetters.bind(this)]), this.validatePrefixNotTaken.bind(this)),
      loginId: new FormControl("", Validators.compose([Validators.required, this.validateUserNameWithoutPeriod.bind(this)])),
      password: new FormControl("", Validators.compose([Validators.required, this.validatePassword.bind(this)])),
      passwordConfirm: new FormControl('', Validators.compose([Validators.required, this.validatePasswordsMatch.bind(this)])),
      pin: new FormControl("", Validators.compose([Validators.required, this.validatePinLength.bind(this), this.validatePinNumbers.bind(this)])),
      pinConfirm: new FormControl("", Validators.compose([Validators.required, this.validatePinsMatch.bind(this)]))
    });
  }

  
  ngOnInit() {
    this.onCreateForm.emit(this.formGroup);
  }

  validatePrefixNumbersandLetters(control: AbstractControl) {
    return /^[a-zA-Z0-9]+$/.test(control.value) ? null : {"Prefix can only be numbers and letters.": true};
  }

  validateUserNameWithoutPeriod(control: AbstractControl) {
    return /^[^.]*$/.test(control.value) ? null : {"Username may not contain a period(.)": true};
  }

  validatePrefixNotTaken(control: AbstractControl) {
    return this.trialService.isPrefixAvailable(control.value).pipe(map(res => {
      return res.available ? null : {"This prefix is taken.": true};
    }));
  }

  validatePinLength(control: AbstractControl) {
    return control.value.length == 6 ? null : {"PIN must be exactly 6 numbers.": true}
  }

  validatePinNumbers(control: AbstractControl) {
    var errs = {};
    let isNumbers = /^\d+$/.test(control.value);
    if(!isNumbers) {
      errs["PIN must only be numbers."] = true;
    }

    if(control.value.length > 0 && '1234567890'.indexOf(control.value) != -1) {
      errs["Please pick a stronger PIN."] = true;
    }

    if(control.value.length > 0 && '0987654321'.indexOf(control.value) != -1) {
      errs["Please pick a stronger PIN."] = true;
    }
    return errs;
  }

  validatePinsMatch(control: AbstractControl) {
    if(!this.formGroup) {
      return null;
    }
    let pin = this.formGroup.get('pin');
    let pinConfirm = this.formGroup.get('pinConfirm');
    return pin.value == pinConfirm.value ? null : {"PINs do not match.": true};
  }

  validatePassword(control: AbstractControl) {
    let errs = {};
    let regTest = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[~`!@#$%^&*()<>?,./;':{}|\[\]\-=_+]).{8,50}$/;
    if(!regTest.test(control.value)) {
      errs['Passwords need a capital letter, number, and special character.'] = true;
    }

    if(control.value.length < 8 || control.value.length > 50) {
      errs['Passwords must be between 8 and 50 characters.'] = true;
    } 
 
    if(this.formGroup)
    {
      let pass = this.formGroup.get('password');
      let passConfirm = this.formGroup.get('passwordConfirm');
  
      if(pass.value != passConfirm.value)
      {
        errs['Passwords do not match.'] = true;
      }
    }

    return errs;
  }

  validatePasswordsMatch(control: AbstractControl) {
    if(!this.formGroup) {
      return null;
    }
    let pass = this.formGroup.get('password');
    let passConfirm = this.formGroup.get('passwordConfirm');
    this.formGroup.get('password').updateValueAndValidity()
    return pass.value == passConfirm.value ? null : {"Passwords do not match.": true};
  }




}
